import RowExpander from './RowExpander'
import TableColumn from './TableColumn'
import getDisplayName from '../utils/getDisplayName'
import shallowEqual from 'fbjs/lib/shallowEqual'
import React, { cloneElement } from 'react'

export default function expandableTable(
  dataGetter,
  expandableRenderer,
  { trackBy }
) {
  function toggleRow(collection, row, index, expanded) {
    const key = row[trackBy] || index

    return Object.assign({}, collection, {
      [key]: expanded
    })
  }

  function toggleAll(data, expanded) {
    return data.reduce((memo, row, index) => {
      return toggleRow(memo, row, index, expanded)
    }, {})
  }

  return function decorateComponent(Component) {
    return class ExpandableTable extends React.Component {
      static displayName = `ExpandableTable(${getDisplayName(Component)})`

      constructor(props) {
        super(props)

        this.handleExpand = this.handleExpand.bind(this)
        this.handleExpandAll = this.handleExpandAll.bind(this)
        this.renderExpand = this.renderExpand.bind(this)
        this.renderExpandHeader = this.renderExpandHeader.bind(this)
        this.renderExpandableTable = this.renderExpandableTable.bind(this)
        this.renderRow = this.renderRow.bind(this)

        this.state = {
          allExpanded: false,
          expandedRows: {}
        }
      }

      shouldComponentUpdate(nextProps, nextState) {
        return (
          !shallowEqual(this.props, nextProps) ||
          !shallowEqual(this.state, nextState)
        )
      }

      getExpandableColumn() {
        return (
          <TableColumn
            cellRenderer={this.renderExpand}
            key="expandableColumn"
            dataKey="expandableTableExpanded"
            headerRenderer={this.renderExpandHeader}
            label=""
            width={15}
          />
        )
      }

      handleExpand(rowData, index) {
        const { expandedRows } = this.state
        const key = rowData[trackBy] || index
        const expanded = expandedRows[key]

        this.setState({
          expandedRows: toggleRow(expandedRows, rowData, index, !expanded)
        })
      }

      handleExpandAll() {
        const { allExpanded } = this.state

        this.setState({
          allExpanded: !allExpanded,
          expandedRows: toggleAll(dataGetter(this.props), !allExpanded)
        })
      }

      rowIsExpanded(rowData, index) {
        const key = rowData[trackBy] || index
        return this.state.expandedRows[key]
      }

      renderExpand(_, rowData, dataKey, index) {
        return (
          <RowExpander
            expanded={this.rowIsExpanded(rowData, index)}
            onClick={() => this.handleExpand(rowData, index)}
          />
        )
      }

      renderExpandHeader() {
        const { allExpanded } = this.state

        return (
          <RowExpander expanded={allExpanded} onClick={this.handleExpandAll} />
        )
      }

      renderRow(rowData, rowSchema, index) {
        return (
          <tbody key={index}>
            {rowSchema}
            {this.rowIsExpanded(rowData, index) &&
              expandableRenderer(rowData, this.props)}
          </tbody>
        )
      }

      renderExpandableTable(Table) {
        return cloneElement(
          Table,
          {
            striped: false,
            rowRenderer: this.renderRow,
            wrapInTbody: false,
            className: 'table-expandable'
          },
          [
            this.getExpandableColumn(),
            ...React.Children.toArray(Table.props.children)
          ]
        )
      }

      render() {
        const { expandedRows } = this.state

        return (
          <Component
            connectExpandableColumn={this.renderExpandableTable}
            expandedRows={expandedRows}
            {...this.props}
          />
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ../src/components/ExpandableTable.js